<div class="d-flex flex-row">

    <div class="ml-2">
    <!-- Tasks Section -->
    <div class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-tasks mr-2 text-secondary"></i>
                <span>Tasks</span>
            </div>
        </div>
        <div>
            <button *ngIf="appConfig.scout.enabled"
                class="btn btn-secondary btn-sm m-1"
                (click)="showTaskList({type:'Scout'})">
                <i class="fa fa-search mr-2"></i>Scouts
            </button>
            <button *ngIf="appConfig.pathTest.enabled"
                class="btn btn-secondary btn-sm m-1"
                (click)="showTaskList({type:'Test'})">
                <i class="fa fa-building mr-2"></i>Indoor Tests
            </button>
            <button *ngIf="appConfig.driveTest.enabled"
                class="btn btn-secondary btn-sm m-1"
                (click)="showTaskList({type:'Drive'})">
                <i class="fa fa-car mr-2"></i>Drive Tests
            </button>
            <button *ngIf="appConfig.mobileTest.enabled && roleMgr.canEditUsers"
                title="Volunteer (Real user testing)"
                class="btn btn-secondary btn-sm m-1"
                (click)="showVolunteerTasks()">
                <i class="fa fa-mobile-alt mr-2"></i>RUT Tests
            </button>
        </div>
    </div>

    <!-- Field Engineer Testing Section -->
    <div *ngIf="roleMgr.canEditUsers" class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5" title="Field engineer testing (building and drive tests)">
                <i class="fa fa-hard-hat mr-2 text-secondary"></i>
                <span>Cart Testing</span>
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('user list')"
                title="Backoffice and Field Engineers">
                <i class="fa fa-users mr-2"></i>Users
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showViewWithStage('handsets')">
                <i class="fa fa-mobile mr-2"></i>Handsets
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showViewWithStage('call logs')">
                <i class="fa fa-phone mr-2"></i>Call Logs
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('dialer call logs')">
                <i class="fa fa-phone-square mr-2"></i>Dialer Call Logs
            </button>
        </div>
    </div>

    <!-- RUT Testing Section -->
    <div *ngIf="appConfig.mobileTest.enabled && roleMgr.canEditUsers" class="card my-3 p-1">
        <div class="m-0 card-title" title="Volunteer (real user, not field engineer)">
            <div class="p-2 m-0 h5">
                <i class="fa fa-mobile-alt mr-2 text-secondary"></i>
                <span>RUT Testing</span>
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('volunteer list')"
                title="RUT Mobile Users">
                <i class="fa fa-users mr-2"></i>Users
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('volunteer handsets')">
                <i class="fa fa-mobile mr-2"></i>Handsets
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('rut call logs')">
                <i class="fa fa-phone mr-2"></i>Call Logs
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('volunteer points')">
                <i class="fa fa-map-marker-alt mr-2"></i>Accessible Points
            </button>
        </div>
    </div>

    <!-- Import Section -->
    <div class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-file-import mr-2 text-secondary"></i>
                <span>Import</span>
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('file import')">
                <i class="fa fa-file-import mr-2"></i>File Import
            </button>
            <div class="btn-group m-1" dropdown container="body" *ngIf="roleMgr.canEditUsers">
                <button class="btn btn-sm btn-secondary" dropdownToggle>
                    <i class="fa fa-clipboard-check mr-1"></i>Integrity
                    <i class="fa fa-chevron-down ml-1"></i>
                </button>
                <div *dropdownMenu class="dropdown-menu p-2" style="min-width: 400px;">
                    <div class="d-flex flex-row mb-2">
                        <button class="btn btn-secondary btn-sm m-1 text-nowrap" (click)="showView('Points Audit')">
                            <i class="fa fa-search mr-2"></i>Scout/Point Discrepancies
                        </button>
                        <button class="btn btn-secondary btn-sm m-1 text-nowrap" (click)="showView('missing handsets')">
                            <i class="fa fa-exclamation-triangle mr-2"></i>Missing Handsets
                        </button>
                    </div>
                    <div class="card">
                        <h6 class="m-2 text-secondary">
                            <i class="fa fa-database mr-2"></i>One Source
                        </h6>
                        <div class="d-flex flex-row">
                            <button class="btn btn-secondary btn-sm m-1 text-nowrap" (click)="showView('RxDB Buildings')">
                                <i class="fa fa-building mr-2"></i>Buildings
                            </button>
                            <button class="btn btn-secondary btn-sm m-1 text-nowrap" (click)="showView('RxDB Points')">
                                <i class="fa fa-map-marker-alt mr-2"></i>Points
                            </button>
                            <button class="btn btn-secondary btn-sm m-1 text-nowrap" (click)="showView('RxDB Paths')">
                                <i class="fa fa-route mr-2"></i>Paths
                            </button>
                            <button class="btn btn-secondary btn-sm m-1 text-nowrap" (click)="showView('RxDB Waypoints')">
                                <i class="fa fa-map-pin mr-2"></i>Waypoints
                            </button>
                            <button class="btn btn-secondary btn-sm m-1 text-nowrap" *ngIf="roleMgr.isAdmin" (click)="showView('Markets')">
                                <i class="fa fa-globe mr-2"></i>Markets
                            </button>
                        </div>
                        <div class="d-flex flex-row">
                            <button class="btn btn-outline-warning btn-sm m-1 text-nowrap" (click)="clearOneSourceCollections()">
                                <i class="fa fa-sync-alt mr-2"></i>Rebuild All
                            </button>
                            <button class="btn btn-outline-success btn-sm m-1 text-nowrap" (click)="exportOneSource()">
                                <i class="fa fa-download mr-2"></i>Export
                            </button>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>

    <!-- Data Analysis Section -->
    <div *ngIf="roleMgr.canEditUsers" class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-chart-line mr-2 text-secondary"></i>
                <span>Data Analysis</span>
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <button class="btn btn-secondary btn-sm m-1" (click)="showViewWithStage('location logs')">
                <i class="fa fa-map-marker-alt mr-2"></i>Location Logs
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showViewWithStage('correlation')">
                <i class="fa fa-table mr-2"></i>Correlation Logs
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showViewWithStage('correlation dashboard')">
                <i class="fa fa-chart-line mr-2"></i>Correlation Dashboard
            </button>
        </div>
    </div>

    <!-- Project Management Section -->
    <div *ngIf="roleMgr.canEditUsers || roleMgr.canSchedule" class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-clipboard-list mr-2 text-secondary"></i>
                <span>Project Status</span>
            </div>
        </div>
        <div class="d-flex flex-wrap align-items-center">
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('building status')">
                <i class="fa fa-building mr-2"></i>Building
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('path status')">
                <i class="fa fa-route mr-2"></i>Path
            </button>
        </div>
    </div>


    </div>

    <div class="pl-3">
    <!-- Preferences Section -->
    <div class="card my-3">
        <div class="m-0 card-title">
            <div class="d-flex justify-content-between align-items-top">
                <div class="p-2 m-0 h5">
                    <i class="fa fa-cogs mr-2 text-secondary"></i>
                    <span>Preferences</span>
                </div>
                <div>
                <button class="btn btn-secondary btn-sm m-1"
                    (click)="toggleDarkTheme()"
                    [attr.title]="preferences.isDarkTheme?'Switch to light theme':'Switch to dark theme'"
                    >
                    <i *ngIf="preferences.isDarkTheme" class="fa fa-sun">

                    </i>
                    <i *ngIf="!preferences.isDarkTheme" class="fa fa-moon">

                    </i>
                </button>
                </div>
            </div>
            <form #preferencesForm="ngForm" class="m-1">
                <div *ngIf="errorMsg" class="alert alert-danger mb-3">{{errorMsg|shorten:120:'...'}}</div>
                <div class="input-group input-group-sm">
                    <div class="p-2 d-flex align-items-center">
                        <label for="stageSelect" class="text-nowrap mr-2 mb-0">
                            Active Stage:
                        </label>
                        <select name="stage" class="form-control form-control-sm" id="stageSelect" *ngrxLet="stages$ as stages"
                            [(ngModel)]="preferences.stage" #stageSelect="ngModel" (ngModelChange)="onStageChanged($event)"
                            [ngClass]="{ 'invalid-input': stageSelect.invalid && (stageSelect.dirty || stageSelect.touched)}">
                            <option *ngFor="let stage of stages" [ngValue]="stage?.name">{{stage?.name||'--- ALL ---'}}</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <!-- Dialer Section -->
    <div *ngIf="!roleMgr.canSchedule" class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-phone text-secondary mr-2"></i>
                <span>Dialer</span>
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('dialer config')">
                <i class="fa fa-cog mr-2"></i>Configuration
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="enableDialer(!dialerService.bInitialized)">
                <i class="fa mr-2" [class.fa-play]="!dialerService.bInitialized" [class.fa-stop]="dialerService.bInitialized"></i>
                {{dialerService.bInitialized?'Disable':'Enable'}}
            </button>
        </div>
        <div *ngIf="dialerService.bInitialized">
            <div *ngIf="dialerService.networkStatus$ | async as networkStatus; else dialerTime">
                <div *ngIf="!networkStatus.ok; else dialerTime" class="ml-2 p-1 pr-2 d-flex flex-row card text-danger">
                    <i class="p-1 fa fa-exclamation-triangle"></i>
                    {{(networkStatus.error?.message || networkStatus.error?.name || networkStatus.error) | shorten:200:'...'}}
                </div>
            </div>
            <ng-template #dialerTime>
                <div class="d-flex flex-wrap">
                    <div class="small font-italic text-secondary card d-flex flex-row p-1 m-2"
                        *ngIf="dialerTimeInfo$ | async as timeInfo"
                        [attr.title]="timeInfo|json">
                        <div class="font-weight-bold">
                            <i class="fa fa-clock mr-1"></i>Dialer Time (UTC):
                        </div>
                        <div>
                            &nbsp;{{timeInfo?.utc?.isoformat|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
                        </div>
                        <div class="font-weight-bold ml-2">
                            <i class="fa fa-globe mr-1"></i>Time Zone:
                        </div>
                        <div>
                        &nbsp;{{timeInfo?.local?.tzname}}
                        </div>
                        <div *ngIf="timeInfo.warningMsg" class="pl-2 text-danger">
                            &nbsp;<i class="fa fa-exclamation-triangle"></i>
                            {{timeInfo.warningMsg}}
                        </div>
                    </div>
                    <div class="small font-italic text-secondary card d-flex flex-row p-1 m-2"
                        *ngIf="dialerUptimeInfo$ | async as uptimeInfo" [attr.title]="uptimeInfo|json">
                        <div class="font-weight-bold">
                            <i class="fa fa-chart-line mr-1"></i>Service Uptime: {{uptimeInfo.durationMessage}}
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    
    <!-- Barometer Section -->
    <div *ngIf="!roleMgr.canSchedule" class="card my-3 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-thermometer-half mr-2 text-secondary"></i>
                <span>Barometer</span>
            </div>
        </div>
        <div class="d-flex flex-wrap align-items-center">
            <button class="btn btn-secondary btn-sm m-1" (click)="showBaro=!showBaro">
                <i class="fa mr-2" [class.fa-eye]="!showBaro" [class.fa-eye-slash]="showBaro"></i>
                {{showBaro?'Hide':'View'}}
            </button>
            <div *ngIf="showBaro" class="px-1">
                <app-barometer></app-barometer>
            </div>
            <div *ngIf="!showBaro" class="px-1 text-secondary small font-italic">
                <i class="fa fa-usb mr-1"></i>Local USB port
            </div>
        </div>
    </div>
    
    <!-- System Section -->
    <div *ngIf="!roleMgr.canSchedule" class="card m-1 p-1">
        <div class="m-0 card-title">
            <div class="p-2 m-0 h5">
                <i class="fa fa-server mr-2 text-secondary"></i>
                <span>System</span>
            </div>
        </div>
        <div class="d-flex flex-wrap">
            <button class="btn btn-secondary btn-sm m-1" [disabled]="bPrimingRxdbIndices" (click)="primeRxdbIndices()">
                <i class="fa mr-2" [class.fa-database]="!bPrimingRxdbIndices" [class.fa-spinner]="bPrimingRxdbIndices" [class.fa-spin]="bPrimingRxdbIndices"></i>Prime Cache
            </button>
            <button class="btn btn-secondary btn-sm m-1" (click)="showView('event log')">
                <i class="fa fa-list-alt mr-2"></i>Event Log
            </button>
        </div>
    </div>
    </div>
</div>

<div *ngIf="bTabSelected" class="d-flex justify-content-end pr-1">
    <testbed-utc-clock></testbed-utc-clock>
</div>